export enum CODES {
    BOOK_AUTHOR = 'book_author',
    BOOK_ISBN = 'book_isbn',
    BOOK_PAGES = 'book_pages',
    BOOK_SERIES = 'book_series',
    BOOK_TYPES = 'book_types',
    GALLERY = 'gallery',
    OUT_OF_STOCK = 'OUT_OF_STOCK',
    PRODUCT_TYPE = 'product_type',
    SCHOOL_LEVEL = 'school_level',
    SCHOOL_SUBJECTS = 'school_subjects',
    THUMBNAILS = 'thumbnails',
    TYPE_BOOK = 'BOOK',
    TYPE_GRANT_APP = 'GRANT_APP',
    TYPE_GRANT_SET = 'GRANT_SET',
}

export enum SIZES {
    LARGE = '270xauto',
    MEDIUM = '150xauto',
    SMALL = '120xauto',
    ORIGINAL = 'original',
}

export type QuantityState = number | null | string;
